/* ===========================
   BUY BABA — THEME JS
   =========================== */

document.addEventListener('DOMContentLoaded', function () {

  // ===== MOBILE NAV TOGGLE =====
  const navToggle = document.getElementById('navToggle');
  const siteNav = document.getElementById('siteNav');

  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      siteNav.classList.toggle('open');
      navToggle.classList.toggle('active');
      document.body.style.overflow = siteNav.classList.contains('open') ? 'hidden' : '';
    });

    // Close nav on outside click
    document.addEventListener('click', function (e) {
      if (!navToggle.contains(e.target) && !siteNav.contains(e.target)) {
        siteNav.classList.remove('open');
        navToggle.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  // ===== STICKY HEADER SHADOW =====
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 24px rgba(0,0,0,.15)'
        : '0 2px 8px rgba(0,0,0,.08)';
    });
  }

  // ===== CART COUNT UPDATE =====
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.getElementById('cartCount');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(() => {});
  }

  // ===== AJAX ADD TO CART =====
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      const data = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: data
      })
        .then(r => r.json())
        .then(function () {
          btn.textContent = '✓ Added!';
          btn.style.background = '#059669';
          updateCartCount();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
          setTimeout(function () {
            btn.textContent = originalText;
          }, 2000);
        });
    });
  });

  // ===== MOBILE DROPDOWN NAV =====
  document.querySelectorAll('.has-dropdown > .site-nav__link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        const dropdown = link.nextElementSibling;
        if (dropdown) {
          const isOpen = dropdown.style.display === 'block';
          dropdown.style.display = isOpen ? 'none' : 'block';
        }
      }
    });
  });

  // ===== SCROLL REVEAL =====
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .category-card, .testimonial-card, .cert-badge').forEach(function (el) {
    el.classList.add('reveal');
    observer.observe(el);
  });

  // Init cart count on load
  updateCartCount();
});
